export enum AuthEvents {
  TokenExpired
}
